import { HEADER_HEIGHT } from "@/constants/layout";

import {
  colors,
  customEvent,
  GOI_PLATFORM_URL,
  Link,
  MissParlorEventTriggerAndTargetType,
  responsive,
} from "goi_common";
import { PARLOR_FAMILY_MAIN_PATH } from "../constants/event";

export type MissParlorDetailHeaderMenuItems = Record<
  string,
  {
    href: string;
    trigger_and_target: MissParlorEventTriggerAndTargetType["prlr_fam_main"];
  }
>;

interface MissParlorDetailHeaderProps {
  companyName: string;
  menuItems: MissParlorDetailHeaderMenuItems;
}

export const MissParlorDetailHeader = ({
  companyName,
  menuItems,
}: MissParlorDetailHeaderProps) => {
  return (
    <header
      css={responsive({
        width: "100%",

        padding: {
          base: "20px 16px 10px 16px",
          lg: "20px 120px 10px 120px",
        },
        marginTop: HEADER_HEIGHT,
        maxWidth: {
          base: "480px",
          lg: "none",
        },
        background: colors.gray800,
      })}
    >
      <div
        css={responsive({
          display: "flex",
          flexDirection: {
            base: "column",
            lg: "row",
          },
          gap: {
            base: "none",
            lg: "20px",
          },
          justifyContent: "space-between",
        })}
      >
        <div
          className="subtitle_16_b lg_head_24_b white"
          css={{ marginBottom: "12px", fontFamily: "Nanum Myeongjo" }}
        >
          {companyName}
        </div>
        <nav>
          <ul
            className="body_14_m lg_body_18_m white"
            css={responsive({
              display: "flex",
              justifyContent: "space-between",
              gap: "32px",
            })}
          >
            {Object.entries(menuItems).map(
              ([text, { href, trigger_and_target }]) => (
                <li key={href}>
                  <Link
                    href={
                      href.includes("/") ? GOI_PLATFORM_URL + href : `#${href}`
                    }
                    onClick={() => {
                      customEvent({
                        newGtm: {
                          path: PARLOR_FAMILY_MAIN_PATH,
                          trigger_and_target: trigger_and_target,
                        },
                      });
                    }}
                    css={{
                      display: "block",
                    }}
                  >
                    {text}
                  </Link>
                </li>
              )
            )}
          </ul>
        </nav>
      </div>
    </header>
  );
};
